<script>
  // Table view for an entity. Columns come from the entity display config (filtered
  // by density); every cell renders through <EntitySlot>. Standard row actions: an
  // edit link for rows whose serializer sends `edit_url`, and a delete button when
  // `onDelete` is given (named by the config's `deleteLabel`, e.g. Archive); pass an `actions` snippet to fully override. When there
  // are no actions at all, the actions column is omitted entirely.
  import DataGrid from '../ui/data_grid.svelte'
  import Button from '../ui/button.svelte'
  import EntitySlot from './entity_slot.svelte'
  import { columnsForDensity, headerLabel } from '../../lib/entities/slots.js'

  let {
    config,
    rows = [],
    density = 'full',
    loading = false,
    sort = null,
    onsort,
    onDelete = null,
    onToggle = null,
    onImageEdit = null,
    emptyMessage = null,
    actions,
    dragEnabled = false,
    onreorder
  } = $props()

  const cols = $derived(columnsForDensity(config, density))
  const gridColumns = $derived(
    cols.map((c, i) => ({
      key: c.field ? String(c.field) + i : 'col' + i,
      header: headerLabel(c),
      align: c.align ?? (c.renderer === 'points' ? 'right' : 'left'),
      // `nowrap` keeps a short value on one line; `minWidth` (a Tailwind class) stops a long one being squeezed to a word per line.
      cellClass: [c.nowrap && 'whitespace-nowrap', c.minWidth].filter(Boolean).join(' ') || undefined,
      sortKey: c.sortKey,
      entityColumn: c
    }))
  )
  const showActions = $derived(!!(actions || onDelete || rows.some((row) => row.edit_url)))
</script>

{#snippet rowActions(row)}
  {#if actions}
    {@render actions(row)}
  {:else}
    {#if row.edit_url}
      <Button variant="ghost" size="xs" square icon="edit" aria-label="Edit" href={row.edit_url} />
    {/if}
    {#if onDelete}
      <Button variant="ghost" size="xs" square icon="delete" aria-label={config.deleteLabel ?? 'Delete'} title={config.deleteLabel ?? 'Delete'} class="text-error" onclick={() => onDelete(row)} />
    {/if}
  {/if}
{/snippet}

<DataGrid
  columns={gridColumns}
  {rows}
  {loading}
  {sort}
  {onsort}
  {dragEnabled}
  {onreorder}
  actions={showActions ? rowActions : undefined}
  emptyMessage={emptyMessage ?? config.empty?.message ?? 'No records found.'}
  emptyIcon={config.empty?.icon ?? config.icon}
>
  {#snippet cell(row, column)}
    <EntitySlot {row} column={column.entityColumn} {onToggle} {onImageEdit} />
  {/snippet}
</DataGrid>
